<div class="pdf-viewer-modal">

    <div class="pdf-viewer-header">
        <div class="pdf-viewer-title-row">
            <div class="pdf-viewer-logo">
                <img src="assets/icons/cafler.svg" alt="Cafler" class="logo-img" />
            </div>
            <span class="pdf-viewer-name">{{ pdfName }}</span>
        </div>
        <div class="pdf-viewer-actions">
            <button type="button" class="pdf-download-btn" (click)="download()"
                [title]="'SERVICE_DETAILS.REPORT_CARD.1' | translate">
                <img src="assets/icons/cloud-download.svg" alt="" class="btn-icon" />
                <span class="pdf-download-text">{{ 'SERVICE_DETAILS.REPORT_CARD.1' | translate }}</span>
            </button>
            <button type="button" class="pdf-close-btn" (click)="close()">
                <img src="assets/icons/x.svg" alt="Cerrar" class="btn-icon" />
            </button>
        </div>
    </div>

    <div class="pdf-viewer-body">

        <ng-container *ngIf="reportData; else pdfMode">
            <div class="pdf-html-body">
                <app-report-content [details]="reportData" [isEconomicReport]="isEconomicReport"
                    [orderHash]="reportOrderHash" [showPDF]="false">
                </app-report-content>
            </div>
        </ng-container>

        <ng-template #pdfMode>
            <div class="pdf-loader" *ngIf="isLoading && !loadError">
                <span>{{ 'PDF_VIEWER.LOADING' | translate }}</span>
            </div>

            <div class="pdf-error" *ngIf="loadError">
                <p>{{ 'PDF_VIEWER.ERROR' | translate }}</p>
            </div>

            <ng-container *ngIf="pdfSrc && !loadError">
                <div class="pdf-layout">

                    <div class="pdf-sidebar">
                        <button *ngFor="let p of pages; let i = index" type="button" class="pdf-thumb-btn"
                            [class.active]="p === currentPage" (click)="goToPage(p)">
                            <div class="pdf-thumb">
                                <img *ngIf="thumbnails[i]" [src]="thumbnails[i]" alt="Page {{ p }}"
                                    class="pdf-thumb-img" />
                                <div *ngIf="!thumbnails[i]" class="pdf-thumb-placeholder"></div>
                            </div>
                            <span class="pdf-thumb-num">{{ p }}</span>
                        </button>
                    </div>

                    <div class="pdf-main">
                        <pdf-viewer [src]="pdfSrc" [page]="currentPage" [render-text]="false" [original-size]="false"
                            [fit-to-page]="true" [zoom-scale]="'page-width'" [autoresize]="true" [show-all]="false"
                            (after-load-complete)="onPdfLoaded($event)" (error)="onPdfError($event)" class="pdf-canvas">
                        </pdf-viewer>
                    </div>

                </div>
            </ng-container>

            <div class="pdf-empty" *ngIf="!pdfSrc && !isLoading && !loadError">
                <p>{{ 'PDF_VIEWER.EMPTY' | translate }}</p>
            </div>
        </ng-template>

    </div>

</div>